module.exports = __webpack_public_path__ + "img/sarah-weitnauer-avatar.a84721c9.jpg";